import storeE from "../../../store";

export const validateStep5 = () => () => {
  return false;
};

export const validateStep5IATU = () => {
  return isProjectManagerValid() && isPMOsValid() && isSponsorValid();
};

export const isProjectManagerValid = () => {
  const siteInfo = storeE.getState().newSite;
  return !!siteInfo.ProjectManager && siteInfo.ProjectManager.length > 0;
};

export const isPMOsValid = () => {
  const siteInfo = storeE.getState().newSite;
  return !!siteInfo.PMOs && siteInfo.PMOs.length > 0;
};

export const isSponsorValid = () => {
  const siteInfo = storeE.getState().newSite;
  const isRdArchive = siteInfo.Template && siteInfo.Template.id === 6;

  if (siteInfo.isIAPCP || isRdArchive) {
    return (
      !!siteInfo.Sponsor &&
      Array.isArray(siteInfo.Sponsor) &&
      siteInfo.Sponsor.length > 0
    );
  }

  return true;
};



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/Validator.js